import React from "react";
import { EmailDispatchParent } from "../components/email-dispatch/EmailDispatch";

const EmailDispatch = () => {
  return <EmailDispatchParent />;
};

export default EmailDispatch;
